// Texto de un badge numérico (pills del panel del analista: "Solicitudes",
// "Desfases Fintoc"). Convención: sin badge cuando no hay nada pendiente, el
// número crudo hasta `max` y "+max" cuando lo supera, para que el pill no
// crezca con contadores largos.
//
//   formatBadgeCount(0)   → ""
//   formatBadgeCount(3)   → "3"
//   formatBadgeCount(12)  → "+9"
export function formatBadgeCount(count, max = 9) {
	const n = Number(count);
	if (!Number.isFinite(n) || n <= 0) return "";
	if (n <= max) return String(Math.trunc(n));
	return `+${max}`;
}
